import React from 'react';

function TermsAndConditionPage(props) {
  const tandCData = `<div>
    <h3> OVERVIEW</h3>
    
    <p ><span style="font-size:15px;color:black">This document is an electronic record in
     terms of the Information Technology Act, 2000 and will be deemed to be a
     contract formed through electronic means.</span></p>
    
    <p ><span style="font-size:15px;color:black">Blupin Technologies Private Limited, a
     company registered under the Indian Companies Act, 2013, which has its
     registered office at 5<sup>th</sup> Floor, Plot No. 115, Sector 44, Gurgaon,
     Haryana-122003 and operates under its trade name &quot;Mylo&quot;, (hereinafter
     referred to as &quot;Mylo&quot; or &quot;We&quot; or &quot;Us&quot; or
     &quot;Our&quot; or &quot;Company&quot;). </span></p>
    
    <p ><span style="font-size:15px;color:black">This document and rules issued
     thereunder, as applicable and the provisions pertaining to electronic records
     in various statutes as amended by the IT Act and is published in accordance
     with the provisions of applicable laws and regulations and Privacy Policy and
     any other terms available on Mylo Web Platforms (“Terms”) for access or usage
     of &nbsp;</span><span style="color:black"><a href="https://www.mylofamily.com/"><span style="font-size:15px;color: rgb(0, 0, 255);">www.mylofamily.com</span></a></span><span style="font-size:15px;color:black"> and/or
     usage or downloading its mobile based application, a portal of Blupin
     Technologies Private Limited. The website and the mobile based application are
     hereinafter collectively referred to as the &quot;Mylo Web Platforms&quot;.</span></p>
    
    <p ><span style="font-size:15px;color:black">For the purpose of these Terms, wherever
     the context so requires &quot;You&quot;, &quot;Your&quot; or &quot;User&quot;
     shall mean any natural or legal person (company, sole-proprietorship,
     partnership, HUF etc.) who has agreed to become a buyer / service recipient on
     the Mylo Web Platforms by providing relevant data or uses by way of browsing
     the website or downloading mobile applications. </span></p>
    
    <p >When
     You use any of the services provided by Us through the Mylo Web Platforms, You
     will be subject to the rules, guidelines, policies (including privacy policy),
     terms, and conditions applicable to such service, and they shall be deemed to
     be incorporated into these Terms and shall be considered as part and parcel of
     these Terms. We reserve the right, at Our sole discretion, to change, modify,
     add or remove portions of these Terms at any time without any prior written
     notice to You. Users will be notified of any changes made, transactional updates, promotional messages, and order updates, by way of an email, SMS, RCS, Whatsapp, or notification within the platform. Upon notification, it will be the responsibility of users to review
     these changes carefully. Continued use of the Company&apos;s services after the
     notification of changes constitutes acceptance of those changes.</p>
    
    <p ><span style="font-size:15px;color:black">Your continued use of the Mylo Web Platforms, following the posting
     of changes will mean that You accept and agree to the revisions. As long as You
     comply with these Terms, We grant You a personal, non-exclusive,
     non-transferable, limited privilege to enter, use and download the Mylo Web
     Platforms.</span></p>
    
    <p ><span style="font-size:15px;color:black">For the purpose of these Terms, wherever the context so requires,
     “Booking Date” or “Transaction Date” shall mean the date on which the order has
     been placed by the User for purchasing the products or availing the services
     via the Mylo Web Platforms. Further, “Date of Service” shall mean the date on
     which the products will be delivered or the services will be provided by the Mylo.</span></p>
    
    <p ><span style="font-size:15px;color:black">Please note that, accessing, browsing, downloading or otherwise
     using the Mylo Web Platforms indicates Your agreement to all the Terms.
     Therefore, please read the Terms carefully before proceeding. By impliedly or
     expressly accepting these Terms, You also accept and agree to be bound by
     Mylo’s Policies (including but not limited to our Privacy Policy) as amended
     from time to time.</span></p>
    
    <h3 ><span style="color:black">1. USER
     ELIGIBILITY</span></h3>
    
    <p ><span style="color:black">Use of the
     Mylo Web Platforms is available only to persons who can form legally binding
     contracts under Indian Contract Act, 1872. Persons who are &quot;incompetent to
     contract&quot; within the meaning of the Indian Contract Act, 1872 including
     minors, un-discharged insolvents etc. are not eligible to use the Mylo Web
     Platforms. If You are a minor i.e. under the age of 18 years, You shall not be
     eligible as a User of the Mylo Web Platforms and shall not transact on or use
     the Mylo Web Platforms. Further, if you are a minor, Mylo reserves the right to
     deactivate and / or refuse to provide You with access to the Platforms if it is
     brought to Our notice or if it is discovered that You are under the age of 18
     years.</span></p>
    
    <h3 ><span style="color:black">2. PLATFORM
     FOR THE PRODUCTS AND SERVICES</span></h3>
    
    <p ><span style="color:black">2.1. You
     agree that Mylo is a Platform through which Users can purchase various goods
     and avail services related to child care and care for their family from all
     over India. </span></p>
    
    <h3 ><span style="color:black">3. YOUR
     ACCOUNT</span></h3>
    
    <p ><span style="color:black">3.1. In
     consideration of Your use of the Mylo Web Platforms, You agree to:</span></p>
    
    <p ><span style="color:black">3.1.1.
     Provide accurate, current and complete information about You as may be prompted
     by any registration forms and subscription, including, but without limiting,
     Your name, telephone number, mailing address, bank account details, account and
     email address on the Mylo Web Platforms (&quot;Registration Data&quot;);</span></p>
    
    <p ><span style="color:black">3.1.2.
     Maintain and promptly update the Registration Data, and any other information
     You provide to Mylo, to keep it accurate, current and complete;</span></p>
    
    <p ><span style="color:black">3.1.3.
     Maintain confidentiality of Your password and identification;</span></p>
    
    <p ><span style="color:black">3.1.4.
     Notify Mylo immediately of any unauthorized use of Your account or any other
     breach of security;</span></p>
    
    <p ><span style="color:black">3.1.6. Any
     licenses, permits, consents, approvals and intellectual property or other
     rights as may be required for using the services shall be obtained by You at
     Your own cost;</span></p>
    
    <p ><span style="color:black">3.1.7.
     Accept all responsibility for any and all activities that occur under Your
     account (whether through authorized or unauthorized access) including, but
     without limitation to, information retrieved, stored and transmitted through
     the Mylo Web Platforms by You;</span></p>
    
    <p ><span style="color:black">3.1.8.
     Accept all risks of unauthorized access to the Registration Data and any other
     information You provide to Mylo; and</span></p>
    
    <p ><span style="color:black">3.1.9. You
     will ensure compliance with all notices or instructions given by Mylo from time
     to time to enable the use of theMylo
     Web Platforms.</span></p>
    
    <p ><span style="color:black">3.2. You
     agree that if You provide any information that is untrue, inaccurate, not
     current or incomplete or We have reasonable grounds to suspect that such information
     is untrue, inaccurate, not current or incomplete, or not in accordance with
     these Terms, We shall have the right to indefinitely suspend or terminate or
     block access of Your account on the Mylo Web Platforms and refuse to provide
     You with access to the Mylo Web Platforms.</span></p>
    
    <p ><span style="color:black">3.3. You
     agree and consent to receive all communications at the mobile number provided,
     even if this mobile number is registered under DND/NCPR list under TRAI
     regulations. And for that purpose, you further authorise Company to
     share/disclose the information to any third party service provider or any
     affiliates, group companies, their authorised agents or third party service
     providers.</span></p>
    
    <h3 ><span style="color:black">4.
     INVITATION TO OFFER</span></h3>
    
    <p ><span style="color:black">All
     products, services and information displayed on the Mylo Web Platforms
     constitute an invitation to offer. Your order for purchase of products or
     availing the services constitutes Your offer, which shall be subject to the
     Terms as listed herein. Mylo reserves the right to accept or reject Your offer
     in part or in full, with or without any reason whatsoever. </span></p>
    
    <h3 ><span style="color:black">5.
     REGISTRATION</span></h3>
    
    <p ><span style="color:black">5.1. Mylo
     allows You to either sign in to the Mylo Web Platforms with Your Facebook
     account or to sign in with Your email address to register with Us.</span></p>
    
    <p ><span style="color:black">5.2.
     Registration on the Mylo Web Platforms is free for Users. Mylo does not charge
     the User any fee for browsing or seek any opinions from individuals on the Mylo
     Web Platforms. Mylo reserves the right to change its fee policy from time to
     time. In particular, Mylo may at its sole discretion introduce new services and
     modify some or all of the existing services offered on the Mylo Web Platforms.
     In such an event, Mylo reserves the right to introduce fees for the new
     services offered or amend/introduce fees for existing services, as the case may
     be. Changes to the fee policy shall be posted on the Mylo Web Platforms and
     such changes shall automatically become effective immediately after they are
     posted on the Mylo Web Platforms. Unless otherwise stated, all fees shall be
     quoted in Indian Rupees. You shall be solely responsible for compliance with
     all applicable laws including those in India for making payments to Mylo</span></p>
    
    <h3 ><span style="color:black">6. TERMS
     &amp; CONDITIONS FOR OBJECTIONABLE CONTENT</span></h3>
    
    <p ><span style="color:black">6.1 Mylo
     has a zero tolerance policy regarding objectionable content. Objectionable
     content may not be uploaded or displayed to the extent such content includes,
     is in conjunction with, or alongside any, Objectionable Content includes, but
     is not limited to: (i) sexually explicit materials, (ii) obscene, defamatory,
     libelous, slanderous, violent and/or unlawful content or profanity! (iii)
     content that infringes upon the rights of any third party, including copyright,
     trademark, privacy, publicity or other personal or proprietary right, or that
     is deceptive or fraudulent! (iv) content that promotes the use or sale of
     illegal or regulated substances, tobacco products, ammunition and/or firearms;
     and (v) gambling, including without limitation, any online casino, sports
     books, bingo or poker. Any user can flag content they deem objectionable for
     review. Content will be moderated by Mylo to ensure the timely removal of any
     and all objectionable content. User accounts which have been confirmed
     responsible for Peeling objectionable content will be restricted from access to
     the Mylo app.</span></p>
    
    <h3 ><span style="color:black">7. GENERAL
     TERMS AND TAKEDOWN POLICY</span></h3>
    
    <p ><span style="color:black">7.1. By
     registering with us as per Clause 5 and transacting via the Mylo Web Platforms
     to purchase any products or avail the online services, You represent to Mylo
     that such registration and purchase is for Your personal and non-commercial use
     only. Further while using the Mylo Web Platforms, You acknowledge that You
     fully assume the risks of purchase and sale transactions and You further fully
     assume the risks of liability or harm of any kind in connection with subsequent
     activity of any kind relating to the product(s) and/or service(s) that are the
     subject of the transactions via the Mylo Web Platforms. </span></p>
    
    <p ><span style="color:black">7.2. Mylo
     reserves the right, at its sole and absolute discretion, to determine whether
     anything posted by You is appropriate; and to remove it, without notice or
     liability to You, which it determines to be inappropriate. Without limiting the
     generality of the foregoing, the following is a partial and non-exhaustive list
     of the type of activities that Mylo deems to be inappropriate:</span></p>
    
    <p ><span style="color:black">7.2.1.
     Content that criticizes a business or individual beyond that of merely offering
     an opinion;</span></p>
    
    <p ><span style="color:black">7.2.2.
     Content that harasses or advocates harassment of another person;</span></p>
    
    <p ><span style="color:black">7.2.3.
     Content that exploits people in a sexual or violent manner;</span></p>
    
    <p ><span style="color:black">7.2.4. Content
     that contains nudity, violence, or offensive subject matter or contains a link
     to an adult website;</span></p>
    
    <p ><span style="color:black">7.2.5.
     Content that includes racially, ethically, or otherwise objectionable language;</span></p>
    
    <p ><span style="color:black">7.2.6.
     Content that is libelous, defamatory, or otherwise tortious language;</span></p>
    
    <p ><span style="color:black">7.2.7.
     Content that solicits personal information from anyone under 18 years of age;</span></p>
    
    <p ><span style="color:black">7.2.8.
     Content that promotes information known to be false or misleading or promotes
     illegal activities or conduct that is abusive, threatening, obscene, defamatory
     or libelous;</span></p>
    
    <p ><span style="color:black">7.2.9.
     Content that involves the transmission of &quot;junk mail,&quot; &quot;chain
     letters,&quot; or unsolicited mass mailing, instant messaging,
     &quot;spimming,&quot; or &quot;spamming&quot;;</span></p>
    
    <p ><span style="color:black">7.2.10
     Content that is in breach of any rights of a third party including but not
     limited to intellectual property rights.</span></p>
    
    <p ><span style="color:black">7.2.11
     Copying, modifying, translating, publishing, broadcasting, transmitting,
     licensing, sublicensing, assigning, distributing, performing, publicly
     displaying, or selling any Mylo content appearing on or through the Mylo Web
     Platforms. It is further clarified that where any User/third party makes any
     complaint with regards to another User’s uploading of contents mention under
     Clause 7.2 above, such User/third party may intimate Mylo and after
     investigation Mylo shall be entitled to take down such content if it is deemed
     to be a valid complaint based on Mylo’s investigation.</span></p>
    
    <p ><span style="color:black">7.3. Mylo
     expressly reserves the right to investigate and take appropriate legal action
     against anyone who, in Mylo’s sole discretion, violates this provision,
     including without limitation, reporting You to the law enforcement authorities.</span></p>
    
    <p ><span style="color:black">7.4 If any
     content uploaded by Mylo on the Mylo Web Platforms is violative of any right of
     a User or third party (as the case may be) including but not limited to
     intellectual property rights, then pursuant to a complaint made by such person
     to Mylo and a subsequent investigation of the origins of such content in
     question, Mylo shall take down such content where the complaint has been deemed
     valid. It is hereby clarified that to the extent no complaint has been received
     against any content uploaded by Mylo it shall be deemed that such content is
     being used by Mylo in a valid manner with the explicit consent of the actual
     owner of such content (if applicable).</span></p>
    
    <h3 ><span style="color:black">8. PAYMENT</span></h3>
    
    <p ><span style="color:black">8.1. While
     availing any of the payment method/s available on the Mylo Web Platforms, We
     will not be responsible or assume any liability, whatsoever in respect of any
     loss or damage arising directly or indirectly to You due to:</span></p>
    
    <p ><span style="color:black">8.1.1. Lack
     of authorization for any transaction/s, or</span></p>
    
    <p ><span style="color:black">8.1.2.
     Exceeding the preset limit mutually agreed between You and the financial
     services providers you deal with, or</span></p>
    
    <p ><span style="color:black">8.1.3. Any
     payment issues arising out of the transaction, or</span></p>
    
    <p ><span style="color:black">8.1.4.
     Decline of transaction for any other reason/s</span></p>
    
    <p ><span style="color:black">8.2. All
     payments made against any purchase of the products or availing the services,
     shall be compulsorily in Indian rupees (“Transaction Price”).</span></p>
    
    <p ><span style="color:black">8.3. Before
     delivering the products purchased by You or providing the services to You. </span></p>
    
    <p ><span style="color:black">8.4. You
     have specifically authorized Mylo to collect, process, facilitate and remit the
     Transaction Price electronically or through Cash on Delivery to and from other
     Users in respect of transactions through payment facility.</span></p>
    
    <h3 ><span style="color:black">9.
     CANCELLATION POLICY</span></h3>
    
    <p ><span style="color:black">9.1.
     Cancellation of orders can only be made at any time before you receive an
     intimation containing confirmation of your order. No cancellations will be
     accepted post such time and for any cancellation request received post such
     time, you will need to raise a return request after the order has been
     delivered.</span></p>
    
    <h3 ><span style="color:black">10. RETURN
     AND REFUND POLICY</span></h3>
    
    <p ><span style="color:black">Mylo allows
     easy return, replacement &amp; refund of eligible products as per the terms
     specified on <a href=" https://mylofamily.com/refund-cancellation"><span style="font-size:15px;color: rgb(0, 0, 255);"> https://mylofamily.com/refund-cancellation</span></a></span></p>
     
    <h3 ><span style="color:black">11.
     CONFIDENTIAL AND PERSONAL DATA/INFORMATION</span></h3>
    
    <p ><span style="color:black">11.1. Any
     personal and identifiable information that is required to be collected by Us
     shall be kept confidential in accordance with the provisions of our Privacy
     Policy. In addition to the Privacy Policy, the provisions of the following
     laws/ rules/ guidelines/ regulations shall be applicable to the use of these
     Platforms:</span></p>
    
    <p ><span style="color:black">11.2 The
     provisions of Information Technology Act, 2000 relating to the processing of
     personal data as may be amended from time to time;</span></p>
    
    <p ><span style="color:black">11.3 The
     provisions of the Information Technology (Intermediary Guidelines) Rules, 2011
     as may be amended from time to time;</span></p>
    
    <p ><span style="color:black">11.4. The
     provisions of the Information Technology (Reasonable Security Practices and
     Procedures and Sensitive Personal Data or Information) Rules, 2011 as may be
     amended from time to time.</span></p>
    
    <p ><span style="color:black"></span></p>
    
    <h3><span style="color:black">12. </span><span style="color:#1F1F1F">DATA RETENTION</span></h3>
    
    <p ><span style="color:#1F1F1F">12.1. We may retain certain types of data for specific periods
     based on legal and operational requirements:</span></p>
    
    <p ><span style="color:#1F1F1F">12.2. Due to legal obligations or upon receipt of valid
     complaints, we may retain deleted content, including user-generated content,
     posts, messages, and comments, for up to 180 days. This allows us to address
     potential legal disputes or concerns.</span></p>
    
    <p ><span style="color:#1F1F1F">12.3. After account cancellation or withdrawal, we may retain
     your user registration information, such as username, email address, and
     registration date, for up to 180 days. This enables us to handle potential
     inquiries or disputes related to your account.</span></p>
    
     
    <p ><span style="color:#1F1F1F">12.4. When we receive a valid legal order from a government
     agency, we strive to provide the requested information within 72 hours.</span></p>

     <h3><span style="color:black">13.</span><span style="color:#1F1F1F">INTELLECTUAL PROPERTY RIGHTS</span></h3>
    

    <p ><span style="font-size:16px;color:black">
     13.1. Subject to Part B Clause 6, Mylo is the sole
     owner or lawful licensee of all the rights of the Mylo Web Platforms and its
     content. For the purpose of this clause, the content on the Mylo Web Platforms
     includes its design, layout, text, images, graphics, sound, video, etc as well
     as non-superficially visual functional elements. The title, ownership and
     intellectual property rights in the Mylo Web Platforms and its content shall
     remain with Mylo, its affiliates or licensors of the content, as the case may
     be.</span></p>
    
    <p ><span style="color:black">13.2.
     Trademark: &apos;Mylo&apos; and related icons and logos are registered or registration
     has been applied for by Mylo in various jurisdictions and the same is protected
     under applicable trademark and other intellectual property laws. The
     unauthorized copying, modification, use or publication of these marks is
     strictly prohibited and shall be subject to appropriate legal proceedings
     against the unauthorized user.</span></p>
    
    <p ><span style="color:black">13.3.
     Copyright: All content on the Mylo Web Platforms is the copyright of Mylo
     except the third party content and links to third party websites on the Mylo
     Web Platforms, if any.</span></p>
    
    <h3 ><span style="color:black">14.
     DISCLAIMER OF WARRANTIES</span></h3>
    
    <p ><span style="color:black">14.1. All
     the materials and products (including but not limited to software) and
     services, included on or otherwise made available to You through the Mylo Web
     Platforms are provided on &quot;as is&quot; and &quot;as available&quot; basis
     without any representation or warranties, express or implied except otherwise
     specified in writing.</span></p>
    
    <p ><span style="color:black">14.2. Mylo
     does not warrant that: the Mylo Web Platforms will be constantly available, or
     available at all; or that the information on the Mylo Web Platforms is
     complete, true, accurate or non-misleading.</span></p>
    
    <p ><span style="color:black">14.3. As
     per the guidelines issued by the Government of India, Mylo will not exercise
     ownership over the goods and services purported to be sold on the Mylo Web
     Platforms. Thus all commercial/contractual terms are offered by and agreed to
     between the Users and Vendors alone. The commercial/contractual terms may
     include, without limitation, price, shipping costs, payment methods, payment
     terms, date, period and mode of delivery, warranties related to products and
     services.</span></p>
    
    <p ><span style="color:black">14.4. Mylo
     does not make any representation or warranty as to specifics (such as quality,
     value, saleability, etc) of the products or services proposed to be sold or
     offered to be sold or purchased on the Mylo Web Platforms. Mylo does not
     implicitly or explicitly support or endorse the sale or purchase of any
     products or services on the Mylo Web Platforms. By virtue of technical or human
     error, it may be possible that certain inadvertent errors may occur such as
     change in the price of the products and services, change in the quantity
     ordered, description of the products and services and the like. Even though
     Mylo makes its best efforts to avoid any such errors, We will not accept
     liability for any such inadvertent errors or omissions.</span></p>
    
    <p ><span style="color:black">14.5.
     References that We make to any names, marks, products or services of third
     parties or hypertext links to third party sites or information do not
     constitute or imply Our endorsement, sponsorship or recommendation of the third
     party, of the quality of any product or service, advice, information or other
     materials displayed, purchased, or obtained by You as a result of an advertisement
     or any other information or offer in or in connection with the Mylo Web
     Platforms.</span></p>
    
    <p ><span style="color:black">14.6. Mylo
     does not make any representation or warranty as to the item-specifics (such as
     legal title, creditworthiness, identity, etc) of any of its Vendors. You are
     advised to independently verify the bona fides of any particular Vendor that
     You choose to deal with on the Mylo Web Platforms and use Your best judgment in
     that behalf.</span></p>
    
    <p ><span style="color:black">14.7. You
     realize and indemnify Mylo and/or any of its officers and representatives from
     any cost, damage, liability or other consequences of any of the actions of the
     Users of the Mylo Web Platforms and specifically waive any claims that You may
     have in this behalf under any applicable law. Notwithstanding its reasonable
     efforts in that behalf, Mylo cannot take responsibility or control the
     information provided by other Users which is made available on the Mylo Web
     Platforms. You may find other User&apos;s information to be offensive, harmful,
     inconsistent, inaccurate, or deceptive. Please use caution and exercise Your
     own judgment when using the Mylo Web Platforms</span></p>
    
    <h3 ><span style="color:black">15. GENERAL
     PROVISIONS</span></h3>
    
    <p ><span style="color:black">15.1. FORCE
     MAJEURE</span></p>
    
    <p ><span style="color:black">You
     understand and agree that Mylo will not be held liable for any loss or damage
     with respect to the use of the Mylo Web Platforms, if the same arises out of
     any cause due to which Mylo is wholly or partly unable to perform its
     obligations and which is not reasonably within the control of Mylo. Further,
     Mylo will not liable for any loss or damage which is not a result of the fault
     or negligence of Mylo or which occurs despite all reasonable attempts of Mylo
     to avoid or mitigate the same. This includes without limitation, acts of God,
     war, riots, civil disturbances, cyclones, hurricanes, floods, earthquakes,
     storms and other natural calamities, epidemics, plagues, terrorist attacks,
     accidents, trade restrictions, acts of any government authority leading to a
     delay in adhering to the timelines of delivery, strikes, labour, employee
     difficulties and other events or circumstances that are beyond the reasonable
     control of Mylo.</span></p>
    
    <p ><span style="color:black">15.2. INDEMNIFICATION</span></p>
    
    <p ><span style="color:black">You agree
     to indemnify and hold Us and (as applicable) Our officers, directors, agents,
     and employees, harmless from any claim or demand, including reasonable
     attorneys&apos; fees, made by any third party due to or arising out of Your breach
     of these Terms or your violation of any law, or your violation of the rights of
     a third party, including the infringement by you of any intellectual property
     or other right of any person or entity. These obligations will survive the
     termination of these Terms.</span></p>
    
    <p ><span style="color:black">15.3.
     TERMINATION</span></p>
    
    <p ><span style="color:black">You
     understand and agree that Mylo reserves the right to terminate Your
     registration and / or terminate Your right to use the Mylo Web Platforms for
     any reason whatsoever, including without limitation, any act or omission in
     contravention of the Privacy Policy or of these Terms. You further understand
     and agree that any such termination may be effected without prior notice to You
     and You acknowledge and agree that Mylo may delete or deactivate Your account
     immediately upon detecting any such reason, including without limitation, the
     contravention of the Privacy Policy or of these Terms.</span></p>
    
    <p ><span style="color:black">15.4. APPLICABLE
     LAW</span></p>
    
    <p ><span style="color:black">A. The Mylo
     Web Platforms have been designed to comply with the laws of India and hence We
     shall be governed by the laws of India. If any material on the Mylo Web
     Platforms or Your use of the Mylo Web Platforms is contrary to the laws of the
     country / state where You are when You access it, We ask You not to use the
     Mylo Web Platforms in contravention of such law. You are responsible for being
     aware of the laws of Your jurisdiction and complying with them.</span></p>
    
    <p ><span style="color:black">B. Further,
     the courts of Gurugram, Haryana shall have exclusive jurisdiction in case of
     any preliminary relief sought in respect of all the terms, conditions and
     disclaimers.</span></p>
    
    <p ><span style="color:black">15.5. DISPUTE
     RESOLUTION</span></p>
    
    <p ><span style="color:black">All
     disputes or differences arising between You and Mylo as to these Terms or any
     other matter in relation to or in connection with Your use of the Mylo Web
     Platforms, shall be referred to a single arbitrator who shall be appointed by
     Us as per the provisions of the Arbitration and Conciliation Act, 1996 or any
     amendments thereto. The seat of arbitration shall be Gurugram, Haryana and the
     language should be English.</span></p>
    
    <p ><span style="color:black">15.6. </span><span style="color:black">USAGE </span></p>
    
    <p ><span style="color:black">You are
     prohibited from using the App or the Services: (a) for any unlawful purpose;
     (b) to solicit others to perform or participate in any unlawful acts; (c) to
     violate any international, federal, provincial or state regulations, rules,
     laws, or local ordinances; (d) to infringe upon or violate our intellectual
     property rights or the intellectual property rights of others; (e) to harass,
     abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate
     based on gender, sexual orientation, religion, ethnicity, race, age, national
     origin, or disability; (f) to submit false or misleading information; (g) to
     upload or transmit viruses or any other type of malicious code that will or may
     be used in any way that will affect the functionality or operation of the
     Service or of any related website, other websites, or the Internet; (h) to
     collect or track the personal information of other.</span></p>
    
    <p ><span style="color:black">15.7. MISCELLANEOUS</span></p>
    
    <p ><span style="color:black">You agree
     and acknowledge You are solely responsible for compliance with applicable laws.
     If for any reason a court of competent jurisdiction finds any provision or
     portion of the Terms to be unenforceable, the remainder of the Terms will
     continue in full force and effect. These Terms constitute the entire agreement
     between Us and supersedes and replaces all prior or contemporaneous
     understandings or agreements, written or oral, regarding the subject matter of
     these Terms. Mylo reserves the right to investigate complaints or reported
     violations of these Terms and to take any action we deem necessary and
     appropriate. Such action may include reporting any suspected unlawful activity
     to law enforcement officials, regulators, or other third parties. In addition,
     We may take action to disclose any information necessary or appropriate to such
     persons or entities relating to User profiles, email addresses, usage history,
     posted materials, IP addresses and traffic information. Mylo reserves the right
     to seek all remedies available at law and in equity for violations of these
     Terms.</span></p>
    
    <p ><span style="color:black">15.8.
     NOTICES</span></p>
    
    <p ><span style="color:black">All of Our
     notices, demands and other communications must be in writing and will be deemed
     to have been given (a) if mailed by certified mail, postage prepaid, (b) if
     delivered by overnight courier, or (c) if sent by electronic mail, and such
     message is confirmed as received, in each case to the address, fax number or
     email address specified on the Order for the recipient of such notice. All of
     Your notices, demands and other communications must be in writing and will be
     deemed to have been given (a) if mailed by certified mail, postage prepaid or
     if delivered by overnight courier, to Our address.</span></p>
    
    <p ><span style="color:black">15.9. COMPLAINT
     HANDLING</span></p>
    
    <p ><span style="color:black">We
     understand the importance of addressing user concerns promptly and fairly. </span></p>
    
    <p ><span style="color:black">We
     acknowledge all received complaints within 24 hours of receipt.</span></p>
    
    <p ><span style="color:black">We will
     resolve all complaints within 15 days from receipt. We will keep you informed
     about the progress of your complaint throughout the process. </span></p>
    
    <p ><span style="color:black">We
     prioritize the safety and well-being of our Users by swiftly addressing
     complaints regarding content that violates our community guidelines and
     regulatory standards, including the Intermediary Rules. Upon receipt of a
     complaint concerning non-consensual dissemination of private material, nudity,
     sexual acts, or electronic impersonation intended to harass or abuse
     individuals, we commit to reviewing and promptly removing or disabling access
     to such content within seventy-two hours of such reporting. </span></p>
    
    <p ><span style="color:black">15.10. GRIEVANCE
     OFFICER</span></p>
    
    <p ><span style="color:black">In
     accordance with Information Technology Act, 2000 and Consumer Protection Act,
     2019 and rules made there under, the name and contact details of the Grievance
     officer / Nodal Officer who can be contacted with respect to any complaints or
     concerns including those pertaining to breach of these Terms, law, compliance
     and other policies or questions are published as under:</span></p>
    
    <p ><span style="color:black">Grievance
     Officer: Vikram Singh</span></p>
    
    <p ><span style="color:black">E-mail
     address: feedback@mylofamily.com</span></p>
    
    <p ><span style="color:black">[10:00 AM
     to 6:00 PM from Monday to Friday except Public Holidays]</span></p>
    
    <p ><span style="color:black">Nodal
     Officer: Subah Batra</span></p>
    
    <p ><span style="color:black">E-mail
     address: </span><span style="color:black"><a href="mailto:subah.batra@mylofamily.com">subah.batra@mylofamily.com</a></span><span style="color:black">[10:00 AM to 6:00 PM from Monday to Friday except
     Public Holidays]</span></p>
    
    
</div>
`;
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: tandCData,
      }}
    />
  );
}

export default TermsAndConditionPage;
